<template lang="pug">
  .notification.flex.items-start.gap-2
    IconNotification.notification__icon(:size="iconSize")
    .notification__text(:style="{ color: textColor }" v-html="text")
</template>

<script>
import IconNotification from '../components/svg/IconNotification.vue'

export default {
  name: 'NotificationBlock',
  components: {
    IconNotification,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    iconSize: {
      type: [Number, String],
      default: 20,
    },
  },
}
</script>

<style lang="scss">
.notification {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -1.4%;
  color: #726CE7;
  text-align: left;

  &__icon {
    min-width: 20px;
    margin-top: 2px;
  }
}
</style>
